import { useState, useEffect } from "react";
import { getReviews, addReview } from "./api";
//import { FaStar } from "react-icons/fa";
import { Card, Rate, Input, Button, Spin, Empty, Typography, message } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Login from "./Login";
import { auth, signOut } from "./firebase";

const { TextArea } = Input;
const { Title, Text } = Typography;

export default function ReviewSection() {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [user, setUser] = useState(false);
  const [reviewData, setReviewData] = useState({
    userId: "",
    userName: "",
    stars: 0,
    review: "",
  });

  // Fetch reviews on mount
  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    setLoading(true);
    const data = await getReviews();
    const sortedData = data.sort((a, b) => new Date(b.date) - new Date(a.date));
    setReviews(sortedData);
    setLoading(false);
  };

  // Handle text area change
  const handleChange = (e) => {
    setReviewData({ ...reviewData, [e.target.name]: e.target.value });
  };

  // Handle star click
  const handleStarClick = (rating) => {
    setReviewData({ ...reviewData, stars: rating });
  };

  // Handle Review Submission
  const handleAddReview = async () => {
    if (!user) {
      alert("You must be signed in to post a review!");
      return;
    }

    if (reviewData.stars === 0) {
      alert("Please select a star rating before submitting.");
      return;
    }

    setSubmitting(true);
    const success = await addReview({
      ...reviewData,
      userId: user.uid,
      userName: user.displayName,
    });
    setSubmitting(false);

    if (success) {
      fetchReviews(); // Refresh the reviews list
      setReviewData({ ...reviewData, stars: 0, review: "" }); // Reset form
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      setUser(null); // ✅ Fix: use setUser
      message.success("Signed out successfully");
    } catch (error) {
      console.error("Sign-out failed:", error);
      message.error("Failed to sign out");
    }
  };  

  return (
    <div id="review" className="bg-white px-6 py-10">
      <Title level={2} className="text-center text-gray-800">User Reviews</Title>

      {/* Review Cards */}
      {loading ? (
        <div className="text-center mt-8">
          <Spin tip="Loading reviews..." />
        </div>
      ) : (
        <div className="overflow-x-auto py-6">
          <div className="flex gap-6">
            {reviews.length > 0 ? (
              reviews.map((r, index) => (
                <Card
                  key={index}
                  title={<span className="font-semibold">{r.userName}</span>}
                  bordered
                  className="w-80 flex-shrink-0 shadow-md hover:shadow-xl transition"
                >
                  <Rate disabled value={r.stars} /> <br></br>
                  <Text type="secondary">
                    {r.review.split(" ").reduce((acc, word, index) => {
                      if (index % 5 === 0 && index !== 0) acc.push(<br key={index} />);
                      acc.push(word + " ");
                      return acc;
                    }, [])}
                  </Text>
                </Card>
              ))
            ) : (
              <Empty description="No reviews yet." className="mx-auto" />
            )}
          </div>
        </div>
      )}

      {/* Review Form */}
      {user ? (
        <div className="flex justify-center mt-10">
          <Card
            title={
              <div className="flex items-center gap-2">
                <span className="font-semibold">
                  Post a Review | Hello, {user.displayName}
                </span>
                <img
                  src={user.photoURL}
                  alt="profile"
                  className="w-6 h-6 rounded-full"
                />
                <Button size="small" danger onClick={handleSignOut}>
                  Sign Out
                </Button>
              </div>
            }          
            className="w-full max-w-lg shadow-lg"
            bordered
          >
            <div className="mb-4 text-center">
              <Rate
                value={reviewData.stars}
                onChange={handleStarClick}
                className="text-2xl"
              />
            </div>

            <TextArea
              rows={4}
              name="review"
              value={reviewData.review}
              onChange={handleChange}
              placeholder="Write your review..."
              className="mb-4"
            />
            <br></br>
            <br></br>

            <Button
              type="primary"
              block
              loading={submitting}
              onClick={handleAddReview}
            >
              {submitting ? "Uploading Review..." : "Submit Review"}
            </Button>
          </Card>
        </div>
      ) : (
        <div className="flex justify-center mt-10">
          <Card
            className="w-full max-w-md shadow-md text-center flex flex-col items-center gap-4 py-6"
            bordered
          >
            <UserOutlined style={{ fontSize: 30, color: "#aaa" }} />
            <Title level={4} className="mt-2">Login to post a review</Title>
            
            {/* Login Button Component */}
            <Login user={user} onLogin={setUser}/>
          </Card>
        </div>
      )}
    </div>
  );
};
